import React, { useEffect, useState } from 'react';
import { CenterModal } from 'react-spring-modal';
import moment from 'moment';
export default function ShillaOpenModal({
	onClick,
	modalVisible,
	_setModalVisible,
	shillaData,
	textData,
}) {
	const [membershipdata, setMemberShipdata] = useState({});
	const [openModal, setOpenModal] = useState(false);
	const dummyShilla = {
		number: '',
		name: '',
		email: '',
		start_period: '',
		end_period: '',
	};
	const modalState = { ...modalVisible };
	function _settingShillaData(shillaData) {
		if (Object.keys(shillaData).length > 0) {
			setMemberShipdata({
				number: shillaData.nft_no,
				name: `${shillaData?.metadataObject?.attributes[4]?.value} ${shillaData?.metadataObject?.attributes[2]?.value}`, // live-live
				email: shillaData?.metadataObject?.attributes[10]?.value, // live-live
				start_period: shillaData?.metadataObject?.attributes[12]?.value, // live-live
				// start_period: '22/10/01', // 언박싱 날짜 고정
				end_period: shillaData?.metadataObject?.attributes[7]?.value, // live-live
			});
		} else if (Object.keys(shillaData).length === 0) {
			setMemberShipdata({ ...dummyShilla });
		} else {
			setMemberShipdata({ ...dummyShilla });
		}
	}
	useEffect(() => {
		_settingShillaData(shillaData);
	}, []);
	useEffect(() => {
		_settingShillaData(shillaData);
	}, [shillaData]);
	useEffect(() => {
		setOpenModal(modalState.isOpen);
	}, [modalVisible]);

	//  Partners Utility Card
	return (
		<div id='Shilla_container col'>
			<CenterModal
				isOpen={openModal}
				onDismiss={() => {
					_setModalVisible((modalVisible.isOpen = false));
				}}
				contentProps={{ style: applyModalstyle }}
			>
				<div className='Shilla_container'>
					<div className='shilla_content_container'>
						<div className='Shilla_container_headerBox'>
							<h1 className='Shilla_contaniner_header'>
								Konnect SHILLA VIP MEMBERSHIP
							</h1>
							<div
								className='Shilla_container_closeBox'
								style={{ cursor: 'pointer' }}
								onClick={() => {
									_setModalVisible(prev => !prev);
								}}
							>
								<p className='Shilla_container_close'>X</p>
							</div>
						</div>
						<div className='Shilla_inner_container'>
							<img
								className='Shilla_img'
								src={modalVisible.imgUrl}
							/>
							{modalState.unbox !== true &&
							membershipdata &&
							Object.keys(membershipdata).length > 0 ? (
								<div className='Shilla_text_container'>
									<div className='Shilla_textBox'>
										<h3>
											{textData &&
												textData.mypage2[
													'Membership Number'
												]}
										</h3>
										<h3>
											{membershipdata.number === undefined
												? ''
												: membershipdata.number}
										</h3>
									</div>
									<div className='Shilla_textBox'>
										<h3>
											{textData &&
												textData.mypage2[
													'Membership name'
												]}
										</h3>
										<h3>
											{membershipdata.name === undefined
												? ''
												: membershipdata.name}
										</h3>
									</div>
									<div className='Shilla_textBox'>
										<h3>
											{textData &&
												textData.mypage2[
													'Membership Email'
												]}
										</h3>
										<h3>
											{membershipdata.email === '' ||
											undefined
												? '-'
												: membershipdata.email}
										</h3>
									</div>
									<div className='Shilla_textBox'>
										<h3>
											{textData &&
												textData.mypage2[
													'Expiration Period'
												]}
										</h3>
										<h3>
											{membershipdata.start_period ===
											undefined
												? ''
												: membershipdata.start_period}
											~{membershipdata.end_period}
										</h3>
									</div>
								</div>
							) : null}
						</div>
					</div>
					{/* <div className='Shilla_btnBox'> */}
					<div
						className={
							modalState.unbox !== true &&
							membershipdata &&
							Object.keys(membershipdata).length > 0
								? 'Shilla_btnBox'
								: 'Shilla_btnBox double'
						}
					>
						{modalState.unbox !== true &&
						membershipdata &&
						Object.keys(membershipdata).length > 0 ? (
							<button
								onClick={() =>
									_setModalVisible(
										(modalVisible.isOpen = false)
									)
								}
								className='Stake_btn_yes'
							>
								<p>{textData && textData.mypage2.getItem}</p>
							</button>
						) : (
							<>
								<button
									onClick={() =>
										_setModalVisible(
											(modalVisible.isOpen = false)
										)
									}
									className='Stake_btn_yes'
								>
									<p>
										{textData && textData.mypage2.getItem}
									</p>
								</button>
								<button
									onClick={onClick}
									className='Stake_btn_yes'
								>
									<p>{'Check'}</p>
								</button>
							</>
						)}
					</div>
				</div>
			</CenterModal>
		</div>
	);
}
const applyModalstyle = {
	backgroundColor: '#000',
	zIndex: '99999',
	width: '100%',
	border: '1px solid #00B2FF',
	borderRadius: '20px',
	position: 'relative',
	display: 'block',
	maxWidth: '80rem',
	padding: '2%',
	margin: 'auto 5%',
	'--padding': 0,
	height: 'fit-content',
	// maxHeight:"auto"
};
